import { dateToMilliseconds } from 'utils/dateformat'

export type TContainer = {
  id: string
  name: string
  status: string
  sealNumber: string
}

export type TItem = {
  name: string
  count: number
}

export type TComments = {
  storekeeperComment: string
  supportComment: string
}

export type TCargo = {
  id: string
  orderNumber: number
  containers: TContainer[]
  tags: string[]
  comments: TComments
  dateMilliseconds: number
  items: TItem[]
  product: string
}

export type TContainerType = {
  id: string
  name: string
  slug: string
  summary: string
  type: string
  amount: { total: number; used: number }
}

export type TEmptyContainer = {
  id: string
  containerTypeId: string
  name: string
  deliveryType: string
  labelled: boolean
  labelNumber: string
}

export type TEmptyContainers = {
  containerTypeId: string
  emptyContainers: TEmptyContainer[]
}

export type WarehouseStockResponse = TContainerType[]

export type ListByWarehouseResponse = TCargo[]

export type ListEmptyContainersResponse = TEmptyContainers[]

export type TWarehouseFilters = {
  interval?: [Date, Date]
  products?: string[]
  orderNumber?: number
  containerSeal?: number
  deliveryType?: number
  courierWarehouseId?: number
}

export const buildWarehouseFilters = (
  filters: TWarehouseFilters
): Record<string, string | number> => {
  if (!filters) return null

  const records: Record<string, string | number> = {}

  if (filters.interval) {
    records.startAt = dateToMilliseconds(filters.interval[0])
    records.endAt = dateToMilliseconds(filters.interval[1])
  }

  if (filters.products) {
    records.products = filters.products.join(',')
  }

  if (filters.courierWarehouseId !== undefined) {
    records.courierWarehouseId = filters.courierWarehouseId
  }

  if (filters.deliveryType) {
    records.deliveryType = filters.deliveryType
  }

  return records
}
